import { reportFromJSON, ReportRecord } from "common/records/Report";
import { RootActions, RootState } from "common/reducers";
import { RECEIVE_REPORT } from "common/reducers/report.actions";
import { receive } from "common/reducers/Utils";
import { Map, Record } from "immutable";

export const ReportStateRecord = Record({
  byId: Map<number, ReportRecord>(),
  lastSavedById: Map<number, ReportRecord>(),
});

export const initialState = ReportStateRecord();

export type ReportState = typeof initialState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  const model = "reports";
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_REPORT:
      return receive(state, model, reportFromJSON(action.payload));

    default:
      return state;
  }
};
